export default {
  records: '/courier/api/v2/recommend/courier/records'
}
